{
  "actions": {
    "newJob": "أمر خدمة جديد",
    "approveFollowUp": "اعتماد زيارة المتابعة",
    "recordAnswer": "تسجيل رد العميل",
    "invoice": "فوترة العمل المنجز",
    "collect": "تسجيل تحصيل",
    "schedule": "جدولة زيارة",
    "scheduleAnother": "جدولة زيارة أخرى",
    "recordAgreement": "تسجيل موافقة العميل على السعر",
    "openVisit": "فتح الزيارة {{label}}",
    "edit": "تعديل البيانات",
    "waiting": "بانتظار…",
    "history": "السجل",
    "cancel": "إلغاء أمر الخدمة",
    "scheduleNextPart": "جدولة الجزء التالي",
    "repeat": "تكرار أمر الخدمة"
  },
  "toast": {
    "created": "فُتح أمر الخدمة {{number}}",
    "updated": "حُدّث أمر الخدمة {{number}}"
  },
  "register": {
    "title": "أوامر الخدمة",
    "views": "عروض أوامر الخدمة",
    "view": {
      "open": "المفتوحة",
      "awaiting": "بانتظار زيارة",
      "scheduled": "المجدولة",
      "unfinished": "غير المكتملة",
      "ready": "جاهزة للفوترة",
      "completed": "المنجزة",
      "cancelled": "الملغاة",
      "all": "الكل"
    },
    "searchPlaceholder": "ابحث برقم الأمر أو العميل أو الموقع أو المشكلة…",
    "searchLabel": "البحث في أوامر الخدمة",
    "clearSearch": "مسح البحث",
    "tableLabel": "أوامر الخدمة",
    "clearFilters": "مسح عوامل التصفية",
    "forCustomer": "أوامر خدمة {{name}}",
    "notScheduled": "لم تُجدول",
    "missed": "فائتة",
    "filters": {
      "customer": "العميل",
      "anyCustomer": "كل العملاء",
      "team": "الفريق",
      "allTeams": "كل الفرق",
      "work": "العمل",
      "anyWork": "كل حالات العمل",
      "billing": "الفوترة",
      "anyBilling": "كل حالات الفوترة",
      "payment": "الدفع",
      "anyPayment": "كل حالات الدفع",
      "priority": "الأولوية",
      "anyPriority": "كل الأولويات",
      "attention": "يحتاج انتباهًا",
      "anyAttention": "كل التنبيهات",
      "overdue": "متأخر",
      "waitingParts": "بانتظار القطع",
      "waitingCustomer": "بانتظار العميل",
      "followUpPending": "طُلبت زيارة متابعة",
      "collectionsAwaiting": "مبالغ للتحقق",
      "billingMode": "نوع الفوترة",
      "anyBillingMode": "كل أنواع الفوترة",
      "toggle": "عوامل التصفية",
      "more": "تصفية إضافية",
      "origin": "نوع الأمر",
      "anyOrigin": "الطلبات والوقائية"
    },
    "empty": {
      "title": "لا أوامر خدمة بعد",
      "body": "افتح أمر خدمة عندما يتصل العميل بمشكلة.",
      "filteredTitle": "لا أوامر تطابق عوامل التصفية",
      "filteredBody": "غيّر البحث أو عوامل التصفية لعرض أوامر أخرى.",
      "view": "لا أوامر في هذا العرض."
    },
    "filtersCount_zero": "عوامل التصفية",
    "filtersCount_one": "عوامل التصفية، عامل واحد محدد",
    "filtersCount_two": "عوامل التصفية، عاملان محددان",
    "filtersCount_few": "عوامل التصفية، {{n}} عوامل محددة",
    "filtersCount_many": "عوامل التصفية، {{n}} عاملًا محددًا",
    "filtersCount_other": "عوامل التصفية، {{n}} عامل محدد",
    "moreFiltersCount_zero": "تصفية إضافية",
    "moreFiltersCount_one": "تصفية إضافية، عامل واحد محدد",
    "moreFiltersCount_two": "تصفية إضافية، عاملان محددان",
    "moreFiltersCount_few": "تصفية إضافية، {{n}} عوامل محددة",
    "moreFiltersCount_many": "تصفية إضافية، {{n}} عاملًا محددًا",
    "moreFiltersCount_other": "تصفية إضافية، {{n}} عامل محدد"
  },
  "columns": {
    "number": "الأمر",
    "issue": "المشكلة",
    "planned": "زيارة وقائية",
    "customer": "العميل والموقع",
    "nextVisit": "الزيارة التالية",
    "status": "الحالة",
    "priority": "الأولوية",
    "targetDate": "الإنجاز قبل",
    "createdAt": "تاريخ الفتح"
  },
  "form": {
    "newTitle": "أمر خدمة جديد",
    "newDescription": "من اتصل، وأين، وما المشكلة.",
    "editTitle": "تعديل {{number}}",
    "sections": {
      "where": "العميل والموقع"
    },
    "q": {
      "where": "أين",
      "whereFirst": "اختر العميل أولاً.",
      "problem": "ما المشكلة",
      "when": "متى يريدون زيارتنا"
    },
    "when": {
      "any": "أي وقت",
      "today": "اليوم",
      "tomorrow": "غداً",
      "pick": "اختر يوماً",
      "part": "الفترة",
      "anyPart": "أي فترة"
    },
    "facts": {
      "change": "تغيير",
      "changeContact": "تغيير جهة الاتصال في الموقع",
      "add": "إضافة",
      "addContact": "إضافة جهة اتصال في الموقع",
      "noContact": "لا جهة اتصال في الموقع بعد",
      "assets": "الوحدة أو المعدّة (اختياري)"
    },
    "chooseSite": "اختر موقعاً",
    "searchSites": "ابحث بالاسم أو الرمز أو العنوان",
    "noSiteMatch": "لا يوجد موقع مطابق.",
    "newSiteTyped": "موقع جديد «{{name}}»",
    "openHere": {
      "title_zero": "لا أوامر مفتوحة في {{site}}",
      "title_one": "أمر مفتوح واحد في {{site}}",
      "title_two": "أمران مفتوحان في {{site}}",
      "title_few": "{{n}} أوامر مفتوحة في {{site}}",
      "title_many": "{{n}} أمرًا مفتوحًا في {{site}}",
      "title_other": "{{n}} أمر مفتوح في {{site}}",
      "titleOther_zero": "لا أوامر أخرى مفتوحة في {{site}}",
      "titleOther_one": "أمر آخر مفتوح في {{site}}",
      "titleOther_two": "أمران آخران مفتوحان في {{site}}",
      "titleOther_few": "{{n}} أوامر أخرى مفتوحة في {{site}}",
      "titleOther_many": "{{n}} أمرًا آخر مفتوحًا في {{site}}",
      "titleOther_other": "{{n}} أمر آخر مفتوح في {{site}}",
      "seeAll": "كل الأوامر المفتوحة لهذا العميل",
      "failed": "تعذّر التحقق من الأوامر المفتوحة في هذا الموقع.",
      "here_zero": "لا أوامر مفتوحة هنا",
      "here_one": "أمر مفتوح واحد هنا",
      "here_two": "أمران مفتوحان هنا",
      "here_few": "{{n}} أوامر مفتوحة هنا",
      "here_many": "{{n}} أمرًا مفتوحًا هنا",
      "here_other": "{{n}} أمر مفتوح هنا",
      "hereOther_zero": "لا أوامر أخرى مفتوحة هنا",
      "hereOther_one": "أمر آخر مفتوح هنا",
      "hereOther_two": "أمران آخران مفتوحان هنا",
      "hereOther_few": "{{n}} أوامر أخرى مفتوحة هنا",
      "hereOther_many": "{{n}} أمرًا آخر مفتوحًا هنا",
      "hereOther_other": "{{n}} أمر آخر مفتوح هنا",
      "view": "عرض",
      "hide": "إخفاء"
    },
    "newSite": "موقع جديد",
    "newSiteBody": "أدخل عنوان مكان العمل.",
    "noSitesYet": "لا موقع خدمة لهذا العميل بعد: أدخل أول موقع.",
    "siteNamePlaceholder": "فيلا 12، الخوير",
    "directionsPlaceholder": "معالم قريبة، البوابة، الطابق…",
    "mapUrlHint": "رابط من تطبيق الخرائط يبدأ بـ https://",
    "contactHint": "مأخوذة من الموقع؛ غيّرها لهذا الأمر فقط.",
    "issuePlaceholder": "ما أبلغ عنه العميل بكلماته",
    "requestedServicePlaceholder": "مثلاً: صيانة مكيف",
    "targetDateHint": "بعد هذا التاريخ يصبح الأمر غير المكتمل متأخراً.",
    "teamHint": "الفريق المسؤول عن الأمر؛ ولكل زيارة فريقها.",
    "noTeam": "دون فريق بعد",
    "chargeableBody": "يدفع العميل مقابل العمل: أسعار متفق عليها ثم فاتورة.",
    "contractBody": "مشمول بعقد صيانة: تقرير زيارة دون فاتورة زيارة.",
    "notesHint": "تظهر أعلى الأمر لكل من يعمل عليه.",
    "create": "إنشاء الأمر",
    "saveWithoutBooking": "حفظ دون حجز",
    "bookVisit": "حجز زيارة",
    "save": "حفظ التغييرات",
    "errors": {
      "customer": "اختر العميل.",
      "site": "اختر موقع الخدمة أو أدخل موقعاً جديداً.",
      "issue": "صِف المشكلة.",
      "siteName": "سمِّ الموقع.",
      "siteAddress": "أدخل العنوان.",
      "mapUrl": "استخدم رابطاً يبدأ بـ https://",
      "date": "أدخل تاريخاً صحيحاً."
    },
    "sitesFailed": "تعذّر تحميل مواقع الخدمة لهذا العميل. أعد المحاولة قبل إضافة موقع جديد.",
    "more": "تفاصيل إضافية",
    "moreHint": "الفريق، تاريخ الإنجاز، الخدمة المطلوبة، الفوترة، الملاحظات",
    "salesperson": "مندوب المبيعات",
    "salespersonHint": "من باع العمل: تُنسب إليه فواتيره.",
    "salespersonDefault": "مندوب مبيعات العميل",
    "booked": "حُجزت الزيارة: {{team}}، {{date}}",
    "bookedChange": "تغيير",
    "bookFailed": "حُفظ الأمر. احجز زيارته هنا."
  },
  "job": {
    "title": "أمر الخدمة",
    "backToRegister": "العودة إلى أوامر الخدمة",
    "request": "الطلب",
    "noContact": "لم تُسجل جهة اتصال.",
    "openMap": "فتح الخريطة",
    "call": "اتصال",
    "openedBy": "{{date}} بواسطة {{name}}",
    "cancelledTitle": "أُلغي في {{date}}",
    "reasons": {
      "closed": "أمر الخدمة مغلق.",
      "followUpPending": "طلب زيارة متابعة بانتظار القرار: اعتمده أو أعده.",
      "followUpRequired": "سبقت زيارة هذا الأمر: الزيارة التالية تأتي من طلب زيارة متابعة معتمد."
    },
    "cancel": {
      "title": "إلغاء {{number}}؟",
      "description": "تُلغى زياراته المجدولة أيضاً، ويبقى الأمر في السجل ملغى.",
      "reason": "السبب",
      "reasonRequired": "اذكر سبب إلغاء الأمر.",
      "confirm": "إلغاء الأمر",
      "toast": "أُلغي أمر الخدمة {{number}}"
    },
    "waiting": {
      "title": "{{number}} بانتظار…",
      "description": "يظهر على الأمر ما ينتظره حتى تبدأ الزيارة التالية.",
      "label": "بانتظار",
      "partsBody": "القطع مطلوبة أو في الطريق.",
      "customerBody": "على العميل أن يؤكد أو يدفع أو يتيح الوصول.",
      "clear": "لا انتظار",
      "clearBody": "يزيل المؤشر.",
      "cleared": "لم يعد بانتظار شيء",
      "note": "ملاحظة",
      "confirm": "حفظ"
    }
  },
  "next": {
    "title": "الخطوة التالية",
    "followUp": "يطلب {{name}} زيارة أخرى: {{reason}}.",
    "followUpWaiting": "طلب {{name}} زيارة أخرى ({{reason}})، والطلب بانتظار موافقة المدير.",
    "answer": "أُرسل السعر إلى العميل. سجّل ردّه.",
    "answerWaiting": "أُرسل السعر إلى العميل ولم يردّ بعد.",
    "price": "السعر",
    "onSite": "الفريق في الموقع الآن: {{team}}.",
    "invoice": "العمل المنجز جاهز للفوترة.",
    "toInvoice": "للفوترة",
    "collect": "صدرت الفاتورة. سجّل الدفعة عندما يدفع العميل.",
    "toPay": "المتبقي للدفع",
    "visit": "موعد زيارة الفريق: {{date}}.",
    "visitMissed": "فاتت زيارة {{date}}. أعد جدولتها.",
    "visitMissedWaiting": "فاتت زيارة {{date}}.",
    "schedule": "لم تُحجز زيارة بعد.",
    "scheduleAgain": "بقي عمل بعد الزيارة الأخيرة. احجز الزيارة التالية.",
    "scheduleWaiting": "لم تُحجز زيارة بعد، ويحجزها المنسق.",
    "followUpNeeded": "بقي عمل بعد الزيارة الأخيرة. يطلب الفريق الزيارة التالية من صفحة تلك الزيارة.",
    "invoiceWaiting": "العمل منجز وبانتظار الفوترة.",
    "paymentWaiting": "صدرت الفاتورة، وبانتظار دفع العميل.",
    "verify_zero": "لا دفعات بانتظار التحقق.",
    "verify_one": "سجّل الفريق دفعة. تحقّق منها.",
    "verify_two": "سجّل الفريق دفعتين. تحقّق منهما.",
    "verify_few": "سجّل الفريق {{n}} دفعات. تحقّق منها.",
    "verify_many": "سجّل الفريق {{n}} دفعة. تحقّق منها.",
    "verify_other": "سجّل الفريق {{n}} دفعة. تحقّق منها.",
    "reported": "بانتظار التحقق",
    "verifyOne": "تحقّق من الدفعة",
    "verifyQueue": "تحقّق من الدفعات",
    "verifyWaiting": "دفع العميل للفريق، والدفعة بانتظار تحقّق المحاسب منها.",
    "done": "لا شيء متبقٍّ: العمل منجز.",
    "donePaid": "لا شيء متبقٍّ: العمل منجز ومفوتر ومدفوع.",
    "doneContract": "لا شيء متبقٍّ: أُنجز العمل ضمن العقد."
  },
  "sections": {
    "label": "أقسام أمر الخدمة",
    "scope": "البنود",
    "visits": "الزيارات",
    "money": "المبالغ",
    "files": "الملفات"
  },
  "scope": {
    "title": "بنود العمل",
    "add": "إضافة بند",
    "actions": "إجراءات البند",
    "editItem": "تعديل {{item}}",
    "removeItem": "حذف {{item}}",
    "cannotRemove": "أُنجز منه أو فُوتر: لا يمكن حذفه",
    "covered": "مشمول",
    "needsAgreement": "السعر غير موافق عليه",
    "progressHead": "التقدم",
    "progress": "أُنجز {{done}} من {{quantity}}",
    "invoicedQty": "فُوتر {{n}}",
    "chargeableTotal": "إجمالي البنود بمقابل (شامل الضريبة)",
    "contractNote": "البنود مشمولة بالعقد ما لم تُحدد بمقابل (عمل إضافي).",
    "changedNote": "تغيّرت البنود بعد موافقة العميل: سجّل موافقة جديدة على السعر قبل العمل.",
    "declinedNote": "رفض العميل السعر. عدّل البنود أو سجّل موافقة جديدة.",
    "emptyTitle": "لا بنود بعد",
    "emptyBody": "أضف الخدمات والقطع التي يحتاجها الأمر، ثم سجّل موافقة العميل على السعر.",
    "removeTitle": "حذف «{{item}}»؟",
    "removeBody": "يخرج البند من نطاق العمل.",
    "removeAgreedBody": "وافق العميل على هذا البند: سيحتاج الأمر موافقة جديدة على السعر.",
    "remove": "حذف البند",
    "toast": {
      "removed": "حُذف البند"
    }
  },
  "agreements": {
    "version": "v{{n}}",
    "history_zero": "سجل موافقات السعر",
    "history_one": "سجل موافقات السعر ({{n}})",
    "history_two": "سجل موافقات السعر ({{n}})",
    "history_few": "سجل موافقات السعر ({{n}})",
    "history_many": "سجل موافقات السعر ({{n}})",
    "history_other": "سجل موافقات السعر ({{n}})",
    "recordedBy": "سجّلها {{name}}، {{date}}",
    "lines_zero": "لا بنود",
    "lines_one": "بند واحد",
    "lines_two": "بندان",
    "lines_few": "{{n}} بنود",
    "lines_many": "{{n}} بنداً",
    "lines_other": "{{n}} بند"
  },
  "agreement": {
    "title": "تسجيل موافقة العميل على السعر",
    "description": "البنود بمقابل وإجماليها كما يراها العميل.",
    "answerTitle": "رد العميل على v{{n}}",
    "answerDescription": "البنود والإجمالي كما أُرسلت إلى العميل.",
    "shown": "ما يوافق عليه العميل",
    "nothing": "لا بنود بمقابل للموافقة عليها.",
    "total": "الإجمالي",
    "vatIncluded": "الإجماليات شاملة ضريبة القيمة المضافة.",
    "decisionLabel": "رد العميل",
    "decision": {
      "ACCEPTED": "وافق",
      "DECLINED": "رفض",
      "AWAITING": "أُرسل، بانتظار الرد",
      "acceptedBody": "يمكن للفريق تنفيذ العمل بهذه الأسعار.",
      "declinedBody": "لا عمل بهذه الأسعار.",
      "awaitingBody": "أُرسل السعر؛ سجّل الرد لاحقاً."
    },
    "submit": {
      "ACCEPTED": "تسجيل الموافقة",
      "DECLINED": "تسجيل الرفض",
      "AWAITING": "تسجيل الإرسال"
    },
    "errors": {
      "approverName": "من وافق (أو رفض) عن العميل؟"
    },
    "scopeChangedTitle": "تغيّرت البنود",
    "scopeChangedBody": "عدّل أحدهم البنود بعد فتح هذه النافذة. القائمة أعلاه محدّثة الآن: راجعها مع العميل ثم سجّل مجدداً.",
    "evidenceHint": "بعد التسجيل يمكنك إرفاق عرض السعر الموقّع أو صورة من الرسالة.",
    "evidenceTitle": "سُجلت الموافقة على السعر v{{n}}",
    "evidenceDescription": "أرفق الإثبات: عرض السعر الموقّع أو صورة أو لقطة من الرسالة.",
    "version": "الموافقة على السعر v{{n}}",
    "recorded": {
      "ACCEPTED": "وافق العميل على v{{n}}.",
      "DECLINED": "رفض العميل v{{n}}.",
      "AWAITING": "أُرسلت v{{n}}: بانتظار رد العميل.",
      "SUPERSEDED": "سُجلت v{{n}}."
    },
    "addEvidence": "أضف الإثبات",
    "done": "تم",
    "toast": {
      "accepted": "سُجلت الموافقة على السعر v{{n}}",
      "declined": "سُجل رفض السعر v{{n}}",
      "sent": "سُجل إرسال السعر v{{n}}"
    }
  },
  "item": {
    "addTitle": "إضافة بند",
    "editTitle": "تعديل البند",
    "description": "خدمة أو قطعة من الكتالوج، أو نص حر.",
    "contractDescription": "تحدد شروط العقد إن كان مشمولًا أو بمقابل، ما لم تحدده هنا.",
    "source": "مصدر البند",
    "catalogue": "من الكتالوج",
    "catalogueBody": "خدمة أو قطعة بسعرها.",
    "freeText": "نص حر",
    "freeTextBody": "صِفه وحدد سعره.",
    "product": "الخدمة أو القطعة",
    "productPlaceholder": "ابحث بالاسم أو رمز الصنف أو الباركود",
    "descriptionOverride": "الوصف (اختياري)",
    "descriptionPlaceholder": "مثلاً: تبديل مكثف الضاغط",
    "noTax": "دون ضريبة",
    "priceLocked": "فُوتر جزء منه: يبقى السعر كما فُوتر.",
    "chargeableHint": "يدفع العميل مقابله.",
    "coveredHint": "مشمول: لا يُفوتر أبداً.",
    "agreedWarning": "وافق العميل على هذا البند في v{{n}}: تعديله يحتاج موافقة جديدة على السعر.",
    "net": "قبل الضريبة",
    "add": "إضافة البند",
    "save": "حفظ البند",
    "errors": {
      "product": "اختر خدمة أو قطعة، أو انتقل إلى النص الحر.",
      "description": "صِف البند.",
      "quantity": "أدخل كمية أكبر من صفر.",
      "price": "أدخل السعر (صفر أو أكثر)."
    },
    "toast": {
      "added": "أُضيف البند",
      "updated": "حُدّث البند"
    },
    "byTerms": "تحدده شروط العقد (العمالة والقطع والمستهلكات كما ينص العقد).",
    "useTerms": "اتركه لشروط العقد"
  },
  "visits": {
    "title": "الزيارات",
    "emptyTitle": "لا زيارات بعد",
    "emptyBody": "احجز فريقاً في وقت يناسب العميل.",
    "lead": "قائد الزيارة: {{name}}",
    "rescheduled_zero": "لم تُعد جدولتها",
    "rescheduled_one": "أُعيدت جدولتها مرة واحدة",
    "rescheduled_two": "أُعيدت جدولتها مرتين",
    "rescheduled_few": "أُعيدت جدولتها {{n}} مرات",
    "rescheduled_many": "أُعيدت جدولتها {{n}} مرة",
    "rescheduled_other": "أُعيدت جدولتها {{n}} مرة",
    "reschedule": "إعادة الجدولة",
    "cancel": "إلغاء الزيارة",
    "cancelTitle": "إلغاء الزيارة {{label}}؟",
    "cancelTitleShort": "إلغاء الزيارة؟",
    "cancelDescription": "يُبلَّغ الفريق وقائد الزيارة، ويبقى السبب في السجل.",
    "cancelReason": "السبب",
    "cancelReasonRequired": "اذكر سبب إلغاء الزيارة.",
    "cancelConfirm": "إلغاء الزيارة",
    "toast": {
      "cancelled": "أُلغيت الزيارة {{label}}"
    },
    "covers": "تشمل",
    "wholeJob": "تشمل الأمر كله",
    "morePlaces_zero": "دون غيرها",
    "morePlaces_one": "ومكان آخر",
    "morePlaces_two": "ومكانان آخران",
    "morePlaces_few": "و{{n}} أماكن أخرى",
    "morePlaces_many": "و{{n}} مكاناً آخر",
    "morePlaces_other": "و{{n}} مكان آخر",
    "places_zero": "لا أماكن",
    "places_one": "مكان واحد",
    "places_two": "مكانان",
    "places_few": "{{n}} أماكن",
    "places_many": "{{n}} مكاناً",
    "places_other": "{{n}} مكان",
    "noLead": "لم يُحدَّد قائد بعد",
    "cancelReasons": {
      "CUSTOMER": "ألغى العميل",
      "DUPLICATE": "حُجزت مرتين",
      "TEAM": "الفريق غير متاح",
      "OTHER": "سبب آخر"
    },
    "cancelSentence": {
      "CUSTOMER": "ألغى العميل الزيارة.",
      "DUPLICATE": "حُجزت الزيارة مرتين.",
      "TEAM": "الفريق غير متاح."
    },
    "cancelReasonOptional": "السبب (اختياري)"
  },
  "followUps": {
    "title": "طلبات زيارة المتابعة",
    "after": "بعد الزيارة {{label}}",
    "requestedBy": "طلبها {{name}}، {{date}}",
    "decidedBy": "قرّرها {{name}}، {{date}}",
    "approve": "اعتماد وجدولة",
    "return": "إعادة",
    "resubmit": "تعديل وإعادة الإرسال",
    "withdraw": "سحب",
    "openVisit": "فتح زيارة المتابعة",
    "returnTitle": "إعادة طلب زيارة المتابعة · {{number}}",
    "returnDescription": "يرى {{name}} ملاحظتك ويمكنه تعديل الطلب أو سحبه.",
    "returnNote": "ما المطلوب تغييره",
    "returnNoteHint": "مثلاً: أرفق قائمة القطع، أو اقترح تاريخاً آخر.",
    "returnNoteRequired": "اكتب ملاحظة لمقدّم الطلب.",
    "withdrawTitle": "سحب طلب زيارة المتابعة؟",
    "withdrawBody": "لن تُجدول منه زيارة متابعة.",
    "toast": {
      "returned": "أُعيد الطلب إلى {{name}}",
      "withdrawn": "سُحب الطلب"
    }
  },
  "schedule": {
    "title": "جدولة زيارة · {{number}}",
    "description": "اختر الفريق وقائد الزيارة واليوم والفترة الزمنية.",
    "rescheduleTitle": "إعادة جدولة الزيارة {{label}}",
    "rescheduleTitleShort": "إعادة جدولة الزيارة",
    "rescheduleDescription": "قبل وصول الفريق يمكن تغيير التاريخ والفترة والفريق والقائد، وتبقى القيم السابقة في السجل.",
    "approveTitle": "اعتماد زيارة المتابعة · {{number}}",
    "approveDescription": "تُجدول زيارة المتابعة. غيّر التاريخ أو الفترة أو الفريق أو القائد عند الحاجة.",
    "chooseTeam": "اختر فريقاً",
    "chooseLead": "اختر قائد الزيارة",
    "teamFirst": "اختر الفريق أولاً",
    "noMembers": "لا أعضاء نشطين في هذا الفريق.",
    "leadRole": "قائد",
    "noDuration": "غير محددة",
    "hours_zero": "{{n}} ساعة",
    "hours_one": "ساعة واحدة",
    "hours_two": "ساعتان",
    "hours_few": "{{n}} ساعات",
    "hours_many": "{{n}} ساعة",
    "hours_other": "{{n}} ساعة",
    "workHours_zero": "أقل من ساعة عمل",
    "workHours_one": "نحو ساعة عمل واحدة",
    "workHours_two": "نحو ساعتَي عمل",
    "workHours_few": "نحو {{n}} ساعات عمل",
    "workHours_many": "نحو {{n}} ساعة عمل",
    "workHours_other": "نحو {{n}} ساعة عمل",
    "windowHint": "اتركه فارغاً لأي وقت من اليوم.",
    "prefers": "تفضيل العميل: {{part}}. اتركه فارغاً لأي وقت.",
    "notes": "ملاحظات للفريق",
    "reason": "سبب التغيير",
    "reasonHint": "مثلاً: طلب العميل فترة بعد الظهر.",
    "reasonOptional": "سبب التغيير (اختياري)",
    "approveNote": "ملاحظة لمقدّم الطلب",
    "availability": "ذلك اليوم",
    "availabilityOn": "{{date}}",
    "availabilityHint": "اختر فريقاً وتاريخاً لعرض زياراتهم الأخرى.",
    "availabilityFailed": "تعذّر تحميل الزيارات الأخرى.",
    "retry": "أعد المحاولة",
    "teamDay": "{{team}}",
    "leadDay": "زيارات {{name}} الأخرى",
    "free": "لا زيارات أخرى.",
    "overlaps": "تتداخل",
    "overlapTitle": "الفريق أو قائد الزيارة مشغول في ذلك الوقت",
    "overlapBody": "تتداخل هذه الفترة مع:",
    "anyway": "الجدولة رغم ذلك",
    "submit": "جدولة الزيارة",
    "submitReschedule": "إعادة جدولة الزيارة",
    "submitApprove": "اعتماد وجدولة",
    "errors": {
      "team": "اختر فريقاً.",
      "lead": "اختر قائد الزيارة.",
      "date": "اختر التاريخ.",
      "window": "النهاية قبل البداية.",
      "reason": "اذكر سبب نقل الزيارة."
    },
    "toast": {
      "scheduled": "جُدولت الزيارة {{label}}",
      "rescheduled": "أُعيدت جدولة الزيارة {{label}}",
      "approved": "اعتُمدت زيارة المتابعة وجُدولت · {{number}}"
    },
    "covers": {
      "title": "تشمل هذه الزيارة",
      "wholeAction": "الأمر كله",
      "busy": "ضمن {{visit}} في {{date}}",
      "extra": "تشمل أيضاً:",
      "whole_zero": "الأمر كله · لا معدّات",
      "whole_one": "الأمر كله · معدّة واحدة",
      "whole_two": "الأمر كله · معدّتان",
      "whole_few": "الأمر كله · {{n}} معدّات",
      "whole_many": "الأمر كله · {{n}} معدّة",
      "whole_other": "الأمر كله · {{n}} معدّة",
      "chosen_zero": "لا أماكن",
      "chosen_one": "مكان واحد · {{assets}} معدّة",
      "chosen_two": "مكانان · {{assets}} معدّة",
      "chosen_few": "{{n}} أماكن · {{assets}} معدّة",
      "chosen_many": "{{n}} مكاناً · {{assets}} معدّة",
      "chosen_other": "{{n}} مكان · {{assets}} معدّة",
      "free_zero": "لا أماكن خارج الزيارات",
      "free_one": "اختيار المكان الذي لم تشمله زيارة بعد",
      "free_two": "اختيار المكانين اللذين لم تشملهما زيارة بعد",
      "free_few": "اختيار الـ{{n}} أماكن التي لم تشملها زيارة بعد",
      "free_many": "اختيار الـ{{n}} مكاناً التي لم تشملها زيارة بعد",
      "free_other": "اختيار الـ{{n}} مكان التي لم تشملها زيارة بعد",
      "assets_zero": "لا معدّات",
      "assets_one": "معدّة واحدة",
      "assets_two": "معدّتان",
      "assets_few": "{{n}} معدّات",
      "assets_many": "{{n}} معدّة",
      "assets_other": "{{n}} معدّة",
      "checked": "فُحصت {{checked}}/{{total}}",
      "onSite_zero": "لا معدّات في الموقع نفسه.",
      "onSite_one": "معدّة واحدة في الموقع نفسه لا تشملها إلا زيارة للأمر كله.",
      "onSite_two": "معدّتان في الموقع نفسه لا تشملهما إلا زيارة للأمر كله.",
      "onSite_few": "{{n}} معدّات في الموقع نفسه لا تشملها إلا زيارة للأمر كله.",
      "onSite_many": "{{n}} معدّة في الموقع نفسه لا تشملها إلا زيارة للأمر كله.",
      "onSite_other": "{{n}} معدّة في الموقع نفسه لا تشملها إلا زيارة للأمر كله.",
      "hint": "اختر الأماكن التي تشملها هذه الزيارة؛ دون اختيار تشمل الأمر كله."
    },
    "leadOptional": "قائد الزيارة (اختياري)",
    "anyMember": "أي عضو في الفريق",
    "anyMemberHint": "من يبدأ الزيارة يصبح قائدها.",
    "reasonWhen": "مطلوب عند تغيير اليوم أو الفريق.",
    "adjustHint": "اليوم نفسه والفريق نفسه: تعديل بسيط لا يُحتسب إعادة جدولة."
  },
  "money": {
    "figures": "مبالغ أمر الخدمة",
    "scope": "إجمالي الأمر",
    "agreed": "المتفق عليه",
    "completed": "العمل المنجز",
    "invoiced": "المفوتر",
    "paid": "المدفوع",
    "balance": "الرصيد المستحق",
    "reported": "بانتظار التحقق",
    "invoices": "الفواتير",
    "collections": "التحصيل",
    "status": "الحالة",
    "draft": "مسودة",
    "invoiceStatus": {
      "DRAFT": "مسودة",
      "POSTED": "مرحّلة",
      "VOID": "ملغاة"
    },
    "contractNote": "ضمن عقد: لا تُفوتر الزيارات، بل البنود الإضافية بمقابل فقط.",
    "nothingToInvoice": "لا عمل منجز بانتظار الفوترة.",
    "noInvoices": "لا فواتير بعد. فوتر العمل بعد إنجازه.",
    "none": "لا فواتير.",
    "noCollections": "لا مبالغ محصّلة.",
    "noCollectionsYet": "لا مبالغ محصّلة بعد. سجّل ما دفعه العميل للفريق.",
    "collectedBy": "حصّله {{name}}، {{date}}",
    "verify": "تحقق"
  },
  "customer": {
    "repeatJob": "تكرار أمر الخدمة {{number}}",
    "tab": "الخدمة",
    "jobs": "أوامر الخدمة",
    "openOf": "{{open}} مفتوح من {{total}}",
    "allJobs": "كل الأوامر",
    "newJob": "أمر خدمة جديد",
    "newJobHere": "أمر جديد هنا",
    "newJobAt": "أمر جديد هنا، في {{site}}",
    "noJobs": "لا أوامر خدمة لهذا العميل بعد",
    "noJobsBody": "افتح أمر خدمة عندما يبلّغ العميل عن مشكلة.",
    "nextVisit": "الزيارة التالية",
    "opened": "فُتح في {{date}}"
  },
  "sites": {
    "title": "مواقع الخدمة",
    "add": "إضافة موقع",
    "addTitle": "موقع خدمة جديد",
    "editTitle": "تعديل موقع الخدمة",
    "addSubmit": "إضافة الموقع",
    "save": "حفظ الموقع",
    "edit": "تعديل {{name}}",
    "archive": "أرشفة {{name}}",
    "restore": "استعادة {{name}}",
    "archived": "مؤرشف",
    "showArchived": "عرض المؤرشفة",
    "hideArchived": "إخفاء المؤرشفة",
    "noArchived": "لا مواقع مؤرشفة.",
    "empty": "لا مواقع خدمة بعد",
    "emptyBody": "أضف الأماكن التي يعمل فيها الفريق لهذا العميل.",
    "archiveTitle": "أرشفة {{name}}؟",
    "archiveBody": "لن تستخدمه أوامر الخدمة الجديدة، وتحتفظ به أوامره الحالية.",
    "archiveConfirm": "أرشفة الموقع",
    "restoreTitle": "استعادة {{name}}؟",
    "restoreBody": "يمكن لأوامر الخدمة الجديدة استخدامه مجدداً.",
    "restoreConfirm": "استعادة الموقع",
    "toast": {
      "added": "أُضيف الموقع {{name}}",
      "updated": "حُدّث الموقع {{name}}",
      "archived": "أُرشف الموقع {{name}}",
      "restored": "استُعيد الموقع {{name}}"
    }
  },
  "planned": {
    "due": "مستحق في {{date}}",
    "checked": "فُحصت {{checked}} من {{total}} معدّة"
  },
  "usual": {
    "title": "البنود المعتادة",
    "hint": "نقرة واحدة تضيفه: الكمية 1 وبالسعر الظاهر.",
    "add": "إضافة {{item}} بسعر {{price}}",
    "added": "أُضيف {{item}}",
    "undo": "تراجع",
    "removed": "أُزيل {{item}}",
    "source": {
      "SITE": "استُخدم في هذا الموقع",
      "CUSTOMER": "استُخدم لهذا العميل",
      "COMPANY": "يُستخدم كثيرًا"
    }
  }
}
